import axiosInstance from "api/axios.auth.config";
import { usePlanRestrictionContext } from "common/PlanRestrictionContext";
import { useEffect } from "react";

const usePlanRestrictionInterceptor = () => {
  const [open, { toggle }] = usePlanRestrictionContext();

  const excludedRoutes = [
    "/get_all_appraisal_for_an_employee",
    "/timeoff/?page_size=",
  ];

  useEffect(() => {
    // Add the interceptor
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error?.response?.status === 402 &&
          !excludedRoutes.some((route) => error.config.url.includes(route))
        ) {
          if (!open) {
            toggle();
          }
        }
        return Promise.reject(error);
      }
    );

    // Cleanup function to remove the interceptor when the component unmounts
    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [toggle, open]);

  return null;
};

export default usePlanRestrictionInterceptor;
